import { DoodleAnimationQueue } from "../lib/animationQueue";

export default {
    init: (el) => {
        if (el.dataset.animate !== "1") {
            return;
        }
        /* Adds active class to element when 90% of el in viewport */
        let visible = false;
        const threshold = 0.9;
        const observer = new IntersectionObserver(
            async (entries) => {
                if (!visible && entries[0].isIntersecting) {
                    visible = true;
                    DoodleAnimationQueue.addItem({
                        run: AnimateDoodle,
                        param: el
                    });
                }
            },
            { threshold: threshold }
        );

        function AnimateDoodle(el) {
            return new Promise(async (resolve, reject) => {
                el.classList.add("active");
                const paths = el.querySelectorAll("path");
                const durationMultiplier = Number(el.dataset.speed) || 1.5;

                for (let i = 0; i < paths.length; i++) {
                    const length = paths[i].getTotalLength();
                    const anim = paths[i].animate(
                        [
                            { strokeDasharray: `0 ${length}` },
                            { strokeDasharray: `${length} 0` },
                        ],
                        {
                            duration: length * durationMultiplier,
                            fill: "forwards",
                        }
                    );

                    await anim.finished;
                }

                resolve();
            });
        }

        observer.observe(el);

        const path = el.querySelector("path");
        if (path) {
            const length = path.getTotalLength();
            el.style.setProperty("--path-length", length);
        }
    },
};
